import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import swal from "sweetalert"
import Select from "react-select";

import useInputForm from '../../components/CustonHooks/FormHook';
import { paymenttypeService } from '../../services/backoffice/paymenttype.service';
import { tradingmethodService } from '../../services/backoffice/tradingmethod.service';

import { companyService } from '../../services/control/company.service';
import { balanceService } from '../../services/control/balance.service';

export function EditBalance(props) {
    const [paymentType, setPaymentType] = useState([]);
    const [tradingMethod, setTradingMethod] = useState([]);
    const [companyUserProfCatalog, setCompanyUserProfCatalog] = useState([]);
    const [balance, setBalance] = useState({
        tradingMethodId: 0,
        userReceiveId: 0,
        balanceAmount: 0.0,
        folio: "",
        reference: "",
        voucherImage: "",
        paymentTypeId: 0,
        active: true,
        balanceStatus: props.status
    });

    const onSave = () => {
        inputs.paymentTypeId = parseInt(inputs.paymentTypeId);
        inputs.tradingMethodId = parseInt(inputs.tradingMethodId);
        inputs.userReceiveId = parseInt(inputs.userReceiveId);
        inputs.balanceAmount = parseFloat(inputs.balanceAmount);
        inputs.balanceStatus = parseInt(inputs.balanceStatus)
        if (inputs.balanceStatus == 2) {
            balanceService.alertPassword("Asignación").then(result => {
                if (result) {
                    inputs.password = result;
                    balanceService.create(inputs);
                }
                else swal("No se ingreso contraseña", "Favor de Ingresar su contraseña para realizar acción!", "error");
            });
        } else balanceService.create(inputs);
    };

    const handleChangeCompanyUsersCatalog = (event) => {
        setInputs({ ...inputs, userReceiveId: parseInt(event.target.value) });
    }

    const handleChangePaymentType = (event) => {
        setInputs({ ...inputs, paymentTypeId: event.target.value });
    }

    const handleChangeTradingMethod = (event) => {
        setInputs({ ...inputs, tradingMethodId: event.target.value });
    }

    const getUserProfCompanyCatalog = () => {
        companyService.getCompanyUsersCatalog()
            .then((result) => { setCompanyUserProfCatalog(result) });
    }

    const getPaymentType = () => {
        paymenttypeService.getAll()
            .then((result) => setPaymentType(result));
    }

    const getTradingMethod = () => {
        tradingmethodService.getAll()
            .then((result) => setTradingMethod(result));
    }

    useEffect(() => {
        getUserProfCompanyCatalog();
        getPaymentType();
        getTradingMethod();
    }, [props.balance]);

    const userOptions = companyUserProfCatalog.map(item => ({
        value: item.userProfileId,
         label: item.name
    }));

    const handleKeyPress = (e) => {
        const allowedKeys = new Set([
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 
            'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab'
        ]);

        const regex = /^[a-zA-Z0-9\s]$/; 
        const haSuperadoLongitud = inputs.reference.length >= 200;

        if (allowedKeys.has(e.key)) {
            return;
        }

        if (!regex.test(e.key) || haSuperadoLongitud) {
            e.preventDefault();
        }
    };

    const handlePaste = (e) => {
        const pastedText = e.clipboardData.getData('text');
        const haSuperadoLongitud = pastedText.length > 200;
        if (!/^[a-zA-Z0-9\s]*$/.test(pastedText) || haSuperadoLongitud) {
            e.preventDefault();
        }
    };

    const { handleSubmit, handleInputChange, handleInputFileChange, inputs, setInputs } = useInputForm(onSave, balance);

    return (
        <div className="wrapper_details_balance card shadows p-4">
            <form onSubmit={handleSubmit}>
                <fieldset>
                    <legend className="text fnt_medium">{props.status == 1 ? "Solicitar " : "Asignar "}Saldo</legend>
                    <div className="row">
                        {props.status == 2 &&
                            <div className="col-12 col-md-12 col-lg-6">
                                <div className="form-group">
                                    <label>Usuario</label>
                                    <Select
                                        options={userOptions}
                                        onChange={(selectedOption) => {
                                        handleChangeCompanyUsersCatalog({
                                            target: {
                                                name: "userReceiveId",
                                                value: selectedOption.value
                                            }
                                        });
                                      }}
                                      value={userOptions.find(option => option.value === inputs.userReceiveId)}
                                      placeholder="Buscar usuario..."
                                      isSearchable
                                      required
                                      classNamePrefix="select"
                                    />
                                  </div>
                                </div>
                        }
                        <div className="col-12 col-md-12 col-lg-6">
                            <div className="form-group">
                                <label for="reference">Referencia</label>
                                <input type="text" name="reference" id="reference" onChange={handleInputChange} onKeyDown={handleKeyPress} value={inputs.reference} onPaste={handlePaste} className="form-control" />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-6 col-lg-6">
                            <div className="form-group">
                                <label for="">Método de Pago</label>
                                <select className="form-control" id="paymentTypeId" name="paymentTypeId" onChange={handleChangePaymentType} value={inputs.paymentTypeId} required>
                                    <option key="0" value="">Selecciona una opción</option>
                                    {
                                        paymentType.map(item => <option key={item.paymentTypeId} value={item.paymentTypeId}>{item.paymentTypeName}</option>)
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-6">
                            <div className="form-group">
                                <label for="tradingMethodId">Método de Negociación</label>
                                <select className="form-control" id="tradingMethodId" name="tradingMethodId" onChange={handleChangeTradingMethod} value={inputs.tradingMethodId} required>
                                    <option key="0" value="">Selecciona una opción</option>
                                    {
                                        tradingMethod.map(item => <option key={item.tradingMethodId} value={item.tradingMethodId}>{item.tradingMethodName}</option>)
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label for="balanceAmount">Monto</label>
                                <input type="number" name="balanceAmount" id="balanceAmount" onChange={handleInputChange} value={inputs.balanceAmount} className="form-control" min=".01" step=".01" required />
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label for="folio">Folio</label>
                                <input type="text" name="folio" id="folio" onChange={handleInputChange} value={inputs.folio} className="form-control" />
                            </div>
                        </div>
                        <div className="col-12 col-md-4 col-lg-4">
                            <div className="form-group">
                                <label for="voucherImage">Comprobante</label>
                                <input type="file" accept="image/*" name="voucherImage" id="voucherImage" onChange={handleInputFileChange} className="form-control" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <Link className="btn secundary minimum ml-1 mr-1" to="/balance" >Regresar</Link>
                        <button className="btn primary minimum" type="submit">Guardar</button>
                    </div>
                </fieldset>
            </form>
        </div>
    )
}